import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../../assets/images/dt-colored-logotype.png'


const _withScopeId = n => (_pushScopeId("data-v-0bd5ccc8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "room-instructions" }
const _hoisted_2 = { class: "RoomInstructions-container" }
const _hoisted_3 = { class: "print-page" }
const _hoisted_4 = { class: "inset" }
const _hoisted_5 = /*#__PURE__*/_createStaticVNode("<div class=\"center\" style=\"margin-top:60px;\" data-v-0bd5ccc8><h3 data-v-0bd5ccc8>SHARE YOUR SCREEN</h3></div><div class=\"center\" style=\"margin-top:30px;\" data-v-0bd5ccc8><img src=\"" + _imports_0 + "\" width=\"150\" data-v-0bd5ccc8></div><div class=\"center\" style=\"margin-top:60px;\" data-v-0bd5ccc8><h4 data-v-0bd5ccc8>Visit https://connect.goditto.com/ on your device</h4></div><div class=\"center\" style=\"margin-top:80px;font-size:18px;\" data-v-0bd5ccc8>ENTER ROOM CODE</div>", 4)
const _hoisted_9 = { class: "center" }
const _hoisted_10 = {
  class: "center",
  style: {"margin-top":"160px","font-weight":"300","font-size":"18px"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _createElementVNode("h1", _hoisted_9, _toDisplayString(_ctx.room.roomCode), 1),
          _createElementVNode("div", _hoisted_10, "For " + _toDisplayString(_ctx.room.roomName), 1)
        ])
      ])
    ])
  ]))
}